import { render, staticRenderFns } from "./RoomManagement.vue?vue&type=template&id=67846ffc&"
import script from "./RoomManagement.vue?vue&type=script&lang=js&"
export * from "./RoomManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports